// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Wire enum for the server "BulkInviteStatus" type (members + integer values are the
// wire contract). The hand facade in app/common re-exports this and hosts any
// non-derivable helpers; see design/wiki/wire-schemas.md.
export enum BulkInviteStatus {
  Created = 0,
  Duplicate = 1,
  Error = 2,
}
